import { render, staticRenderFns } from "./AdlList.vue?vue&type=template&id=6cf24367&"
import script from "./AdlList.vue?vue&type=script&lang=ts&"
export * from "./AdlList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports